export const scrollToFirstError = (errors = {}) => {
  const firstError = Object.keys(errors).filter(value => value !== '_error')[0];
  const el = document.querySelector(`[name="${firstError}"]`);

  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
    el.focus();
  }
};
